import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  container: {
    marginTop: 15
  }
});